export default __webpack_public_path__ + "static/media/ic_logo_kakao.3fcfc933.svg";